import { Component, Input, TemplateRef, ViewChild } from "@angular/core";
import { NgbOffcanvasRef, NgbOffcanvas } from "@ng-bootstrap/ng-bootstrap";
import { IOffCanvasOptions } from "./off-canvas.interface";

@Component({
  selector: "app-off-canvas",
  templateUrl: "./off-canvas.component.html",
})
export class OffCanvasComponent {
  @ViewChild("offcanvasTemplate") offcanvasTemplate!: TemplateRef<any>;

  @Input() options: IOffCanvasOptions = {
    title: "",
    ngbOptions: {
      position: "end",
    },
  };

  private offcanvasRef!: NgbOffcanvasRef;

  constructor(private offcanvasService: NgbOffcanvas) {}

  open() {
    const options =
      this.options && this.options.ngbOptions
        ? this.options.ngbOptions
        : undefined;
    this.offcanvasRef = this.offcanvasService.open(
      this.offcanvasTemplate,
      options
    );
  }

  close() {
    if (this.offcanvasRef) {
      this.offcanvasRef.dismiss();
    }
  }
}
